import styled from 'styled-components';
import { Image as DefaultImage, Flex as DefaultFlex } from 'rebass';

export const Image = styled(DefaultImage)`
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
`;